import {
  DocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from 'firebase/firestore';
import { DeckLogEntry } from './deck-log-entry.model';
import { DeckId } from './deck.model';
import { UserId } from './user.model';

export type DeckIds = DeckId[];
export type UserIds = UserId[];

export type UserGroupType = 'default' | 'family';

export class UserGroup {
  id: string;
  name: string;
  description: string;
  created: Timestamp;
  deckIds?: DeckIds;
  authorId: UserId;
  watcherIds?: UserIds;
  contributorIds?: UserIds;
  pendingWatcherIds: UserIds;
  pendingContributorIds: UserIds;
  deckLogs?: DeckLogEntry[];
  type?: UserGroupType;
  inviteTokenWatcher?: string;
  inviteTokenContributor?: string;

  constructor(
    id: string,
    name: string,
    description: string,
    created: Timestamp,
    deckIds: DeckIds,
    authorId: UserId,
    watcherIds?: UserIds,
    contributorIds?: UserIds,
    pendingWatcherIds?: UserIds,
    pendingContributorIds?: UserIds,
    deckLogs?: DeckLogEntry[],
    type?: UserGroupType,
    inviteTokenWatcher?: string,
    inviteTokenContributor?: string
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.created = created;
    this.deckIds = deckIds || [];
    this.authorId = authorId;
    this.watcherIds = watcherIds || [];
    this.contributorIds = contributorIds || [];
    this.pendingWatcherIds = pendingWatcherIds || [];
    this.pendingContributorIds = pendingContributorIds || [];
    this.deckLogs = deckLogs || [];
    this.type = type || 'default';
    this.inviteTokenWatcher = inviteTokenWatcher;
    this.inviteTokenContributor = inviteTokenContributor;
  }
  // subcollections
  // users?: User[];
}

export const userGroupConverter = {
  toFirestore: (userGroup: UserGroup) => {
    const data: Record<string, unknown> = {
      id: userGroup.id,
      name: userGroup.name,
      description: userGroup.description,
      created: userGroup.created,
      deckIds: userGroup.deckIds,
      authorId: userGroup.authorId,
      watcherIds: userGroup.watcherIds,
      contributorIds: userGroup.contributorIds,
      pendingWatcherIds: userGroup.pendingWatcherIds,
      pendingContributorIds: userGroup.pendingContributorIds,
      deckLogs: userGroup.deckLogs,
      type: userGroup.type || 'default',
    };
    if (userGroup.inviteTokenWatcher) {
      data['inviteTokenWatcher'] = userGroup.inviteTokenWatcher;
    }
    if (userGroup.inviteTokenContributor) {
      data['inviteTokenContributor'] = userGroup.inviteTokenContributor;
    }
    return data;
  },
  fromFirestore: (snapshot: DocumentSnapshot, options?: SnapshotOptions) => {
    if (!snapshot.exists()) {
      return undefined;
    }
    const data = snapshot.data(options);
    return new UserGroup(
      data['id'],
      data['name'],
      data['description'],
      data['created'],
      data['deckIds'],
      data['authorId'],
      data['watcherIds'],
      data['contributorIds'],
      data['pendingWatcherIds'],
      data['pendingContributorIds'],
      data['deckLogs'],
      data['type'],
      data['inviteTokenWatcher'] ?? undefined,
      data['inviteTokenContributor'] ?? undefined
    );
  },
  toFirestoreUpdateObject: (obj: { name?: string; description?: string }) => {
    const updateObj: any = {};
    if (obj.name) {
      updateObj['name'] = obj.name;
    }
    if (obj.description) {
      updateObj['description'] = obj.description;
    }
    return updateObj;
  },
};
